import { styled } from '@mui/material/styles';
import { SingleLineText } from '@bloomays-lib/ui.shared';
import VeryDissatisfiedRawIcon from '@mui/icons-material/SentimentVeryDissatisfiedSharp';
import VerySatisfiedRawIcon from '@mui/icons-material/SentimentVerySatisfiedSharp';
import { Theme } from '@mui/material/styles';

export type NoteSystemProps = {
  number?: number;
  selected?: number;
  setSelected: (e: number) => void;
};

const NoteSystem = ({ number = 10, selected, setSelected }: NoteSystemProps) => {
  const array = [];
  for (let i = 0; i <= number; i++) {
    array.push(i);
  }
  return (
    <Container>
      <ContainerNote>
        {array?.map((nb, i) => {
          return (
            <SingleLineText
              sx={(theme: Theme) => {
                if (selected === nb) {
                  return {
                    color: theme.palette.neutral.white,
                    backgroundColor: theme.palette.blue[60],
                    borderRadius: 50,
                    width: '45px',
                    height: '45px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:hover': {
                      backgroundColor: theme.palette.blue[20],
                      color: theme.palette.neutral[80],
                      cursor: 'pointer',
                    },
                  };
                }
                return {
                  color: theme.palette.neutral[80],
                  backgroundColor: theme.palette.neutral[10],
                  borderRadius: 50,
                  width: '45px',
                  height: '45px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  '&:hover': {
                    backgroundColor: theme.palette.blue[20],
                    cursor: 'pointer',
                  },
                };
              }}
              key={i}
              text={nb.toString()}
              variant={'subtitle2Medium'}
              onClick={() => setSelected(i)}
            />
          );
        })}
      </ContainerNote>
      <ContainerIcons>
        <VeryDissatisfiedIcon />
        <VerySatisfiedIcon />
      </ContainerIcons>
    </Container>
  );
};

export default NoteSystem;
export { NoteSystem };

const ContainerNote = styled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
}));

const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
}));

const ContainerIcons = styled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
  margin: '20px 0 20px 0',
}));

const VeryDissatisfiedIcon = styled(VeryDissatisfiedRawIcon)(({ theme }) => ({
  color: theme.palette.red[80],
  transform: 'scale(2)',
  marginLeft: '8px',
  cursor: 'pointer',
}));

const VerySatisfiedIcon = styled(VerySatisfiedRawIcon)(({ theme }) => ({
  color: theme.palette.green[80],
  cursor: 'pointer',
  marginRight: '8px',
  transform: 'scale(2)',
}));
